export const handleCallback = (context, event, callback) => {
  if (callback && typeof callback === 'function') {
    callback(context, event);
  }
};
